import styled from 'styled-components'
import { pallete } from 'styles/pallete'

import { FlexStyle } from '../Flex/styles'

export const Box = styled(FlexStyle)`
  background-color: ${pallete.pastel.lightBlue};
  height: 100vh;
  width: 100vw;
`
